import { css as r, styled as o } from "styled-components";
import { Colors as a } from "../../../styles/colors/index.js";
import { Theme as l } from "../../../styles/themes/index.js";
import { BodyHeavy as s } from "../../../styles/typography/index.js";
const i = r`
  &,
  & > small,
  & > span {
    color: rgb(${a.Gray});
  }
`, c = o.span`
  color: rgb(${l.colors.Brand});
  display: inline-flex;
  align-items: baseline;

  span {
    word-break: break-word;
  }

  small {
    font-size: 0.7em;
    line-height: 1.2em;
    ${s}
  }

  ${({ $inactive: e }) => e && i}
`, f = o.span`
  display: block;
`;
export {
  c as DealStampContainer,
  f as DealStampOff
};
